import { Observable } from 'rxjs';

import {
	ChannelNonLinearProcessingLevel,
	Response,
	SpatialSeparation
} from '@shure/shared/angular/data-access/system-api/models';

import { AcousticEchoCancellationChannel } from '../models';

export abstract class AcousticEchoCancellationApiService {
	/**
	 * Get channel which supports aec.
	 */
	public abstract getChannel$(channelId: string): Observable<AcousticEchoCancellationChannel>;

	/**
	 * Enable/disable aec for channel.
	 */
	public abstract toggleAec(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * Update aec processing level for channel.
	 */
	public abstract updateAecLevel(
		channelId: string,
		level: ChannelNonLinearProcessingLevel
	): Observable<Response<void, string>>;

	/**
	 * Update aec reference channel for channel.
	 */
	public abstract updateMonoReferenceChannel(
		channelId: string,
		referenceChannelId: string
	): Observable<Response<void, string>>;

	/**
	 * Update left or right aec reference channel for stereo channel.
	 */
	public abstract updateStereoReferenceChannel(
		channelId: string,
		referenceChannelId: string,
		spatialSeparation: SpatialSeparation
	): Observable<Response<void, string>>;
}
